module.exports = __webpack_public_path__ + "img/@temp_pdf_new.70895882.jpg";